export enum PLAYER_INITIALIZING_STATE {
  IDLE = 'IDLE',
  LOADED = 'LOADED',
}

export enum PLAYER_STRATA_STATUS {
  IDLE = 'IDLE',
  INITIALIZED_READY = 'INITIALIZED_READY',
}
